import { render, staticRenderFns } from "./support.vue?vue&type=template&id=2568ce8e&scoped=true&"
import script from "./support.js?vue&type=script&lang=js&"
export * from "./support.js?vue&type=script&lang=js&"
import style0 from "./support.scss?vue&type=style&index=0&id=2568ce8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568ce8e",
  null
  
)

export default component.exports